import React, {useState, useEffect} from 'react'
import './founder.less'
import Hiruni from '../../../images/HiruniCrop.jpg'

export default ()=>{
    const [readMore, setReadMore] = useState(false);

    return(
        <section className="roots-container">
            <article className="testimony-text anim-three" data-delay="0s">
                <h4 className="anim-three" data-delay="0.2s">
                    the story behind the cause
                </h4>
                <p className="visible-text anim-three" data-delay="0.4s">
                    This initiative is aimed at supporting groups of people in our communities that need help, both
                    financially and otherwise. The eight-year old boy begging for money has a father who is
                    terminally ill and needs a big amount of money just to stay alive. The woman you smile at on the
                    bus is a mom with no support from anyone, trying to raise a child alone. The man who drives
                    you to school may have once fought for his country and lost not an arm or a limb, but a soul.
                    This is a glimpse of the world we live in, a world consisting of people who have real issues that
                    need real solutions.
                    <br/>
                    <br/>
                </p>
                <p className={`${readMore? 'show-text' : 'hidden-text'}`}>
                    “This initiative is aimed at supporting groups of people in our communities that need help, both financially and otherwise. My personal testimony is that my mom is a single mom. Through my teen years I have seen the difficulties my mom faced in meeting the needs of the family by working to gain financial stability while giving attention to my sibling and myself at the same time. This experience taught me that there is more to life and that there are people out there going through the same thing or even worse. Most people are handed an unfair burden to carry on this journey we call life, and at
                    Empower, we do what we can to help them take a load off.
                    <br/>
                    <br/>
                    Sometimes we think we cannot help everyone, but we can do what we can and use what we have. Together, we can go far. I invite you to join hands with us on this journey as we do exciting things to raise funds and strive to make things better for the communities we live in. We financially support single-mom families and plan on doing frequent charity projects around the country when circumstances allow, while also championing community participation along the way. At Empower, we believe in a world without inequality, and our goal is to work towards just that. Every step we take will always be for someone else. After all, we are just walking each other home.
                    <br/>
                    <br/>
                    My gratitude goes out to everyone who partnered with me, supporting this initiative both financially and in other ways, and to everyone out there stepping up to make a change. I am proud of you!”
                </p>
            </article>
            <button className="btn testimony-btn anim-three" type="button" data-delay="0.6s" onClick={()=>{setReadMore(!readMore)}}>
                {readMore ? 'Show Less' : 'Read More'}
            </button>
            <article className="founder-signature-container anim-three" data-delay="0s">
                <div className="founder-image-container anim-three" data-delay="0.4s">
                    <img src={Hiruni} alt="Founder - Hiruni" />
                </div>
                <p className="anim-three" data-delay="0.6s">
                    Hiruni Perera 
                    <br/>
                    Founder- The Empower Initiative
                </p> 
            </article>
        </section>
    )
}